import { Alert, Button, Empty, Space, Typography } from 'antd';
import { IconUserPlus } from '@tabler/icons-react';

const { Text } = Typography;

export function InternshipTab() {
  return (
    <div>
      <Space style={{ marginBottom: 16 }}>
        <Button type="primary" icon={<IconUserPlus size={16} />} disabled>
          Начать стажировку
        </Button>
      </Space>

      <Alert
        type="warning"
        showIcon
        style={{ marginBottom: 24, width: '100%' }}
        message="Недоступно в demo-режиме. Управление стажировками и допуском к самостоятельной работе будет доступно в следующей версии."
      />

      <Empty description={<Text type="secondary">Активных стажировок нет</Text>} />
    </div>
  );
}
